import * as React from "react";
const SvgFiRrArrowToRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M21.985 6.015v4.518q-.106-.15-.233-.285L16.8 5.3a1 1 0 1 0-1.414 1.414l4.3 4.3H1.015a1 1 0 0 0 0 2h18.677l-4.3 4.3a1 1 0 1 0 1.408 1.42l4.95-4.95q.126-.135.233-.286v4.517a1 1 0 0 0 2 0v-12a1 1 0 1 0-2 0z"
    />
  </svg>
);
export default SvgFiRrArrowToRight;
